export type UserIncidentWorkspaceFocus = {
  artifactId?: string;
};

export function appendUserIncidentWorkspaceFocus(
  params: URLSearchParams,
  focus: UserIncidentWorkspaceFocus,
): URLSearchParams {
  const nextParams = new URLSearchParams(params);

  if (focus.artifactId) {
    nextParams.set("focusIncidentArtifactId", focus.artifactId);
  }

  return nextParams;
}

export function readUserIncidentWorkspaceFocus(
  params: URLSearchParams,
): UserIncidentWorkspaceFocus | undefined {
  const artifactId = params.get("focusIncidentArtifactId")?.trim();

  if (!artifactId) {
    return undefined;
  }

  return {
    artifactId,
  };
}
